<template>
  <div :aria-hidden="isMobile" class="hidden md:block">
    <div class="flex justify-between">
      <ContainerProductTitles />

      <ContainerRatingInfo />

      <PopularityStatsSalesCaption
        v-if="popularityStatsResponse && popularityStatsResponse[0]"
        :popularity-stats-sales="popularityStatsResponse[0]"
      />

      <div class="mt-24 flex flex-col items-start gap-12">
        <JPContainerPrice />
        <ContainerAddToCart
          class="mood-tangaroa min-w-[164px] max-w-[256px] grow"
          data-id="product-page-buy-button-desktop"
          data-qa="product-page-buy-button-desktop"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useClientOnlyComputedBreakpoint } from '@backmarket/utils/composables/useClientOnlyComputedBreakpoint'
import { Breakpoint } from '@backmarket/utils/dom/getCurrentBreakpoint'

import ContainerAddToCart from '~/scopes/product-core/components/ContainerAddToCart/ContainerAddToCart.vue'
import ContainerRatingInfo from '~/scopes/product-core/components/ContainerProductSummary/components/ContainerRatingInfo/ContainerRatingInfo.vue'
import ContainerProductTitles from '~/scopes/product-core/components/ContainerProductTitles/ContainerProductTitles.vue'
import { useFetchPopularityStatsSales } from '~/scopes/product-core/composables/useFetch/useFetchPopularityStatsSales/useFetchPopularityStatsSales'
import JPContainerPrice from '~/scopes/product-core/pages/ProductDetailPage/jp/components/JPContainerPrice/JPContainerPrice.vue'
import PopularityStatsSalesCaption from '~/scopes/product-core/pages/ProductDetailPage/jp/components/presentationals/PopularityStatsSalesCaption/PopularityStatsSalesCaption.vue'

const { data: popularityStatsResponse } = useFetchPopularityStatsSales()

// @FIXME: potential hydration mismatch caused by client-only breakpoint detection
const breakpoint = useClientOnlyComputedBreakpoint()
const isMobile = computed(() => breakpoint.value < Breakpoint.MD)
</script>
